import React from 'react';
import { generatePlatformSettingsTabs } from '../platformSettingsTabUtils';

export const NEW_HIRE_EXPERIENCE_TAB_GROUP_ID = 'new-hire-experience';

const NEW_HIRE_EXPERIENCE_TAB_COMPONENTS_BY_ID = {
  'welcome-message': React.lazy(() => import('./WelcomeMessage/WelcomeMessageSettings')),
  'preboarding-complete-note': React.lazy(() => import('./PreboardingCompleteNote/PreboardingCompleteNoteSettings')),
  people: React.lazy(() => import('./People/PeopleSettings')),
};

export const NEW_HIRE_EXPERIENCE_TABS = generatePlatformSettingsTabs(
  NEW_HIRE_EXPERIENCE_TAB_COMPONENTS_BY_ID,
  NEW_HIRE_EXPERIENCE_TAB_GROUP_ID,
);
